import React, { useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet-async'
import { FaLeaf, FaFireAlt, FaClock, FaSnowflake } from 'react-icons/fa'
import ImagePlaceholder from '../components/ImagePlaceholder'

const CATEGORIES = ['Todos', 'Proteico', 'Low Carb', 'Vegetariano', 'Infantil']

const PRODUCTS = [
  { name: 'Frango Grelhado com Arroz Integral e Brócolis', category: 'Proteico',   kcal: '420 kcal', protein: '38g', tag: 'Mais vendido' },
  { name: 'Carne Assada com Batata Doce e Legumes',        category: 'Proteico',   kcal: '490 kcal', protein: '35g', tag: null },
  { name: 'Salmão com Quinoa e Aspargos',                  category: 'Low Carb',   kcal: '380 kcal', protein: '34g', tag: 'Premium' },
  { name: 'Filé de Tilápia com Abobrinha e Cenoura',       category: 'Low Carb',   kcal: '310 kcal', protein: '30g', tag: null },
  { name: 'Risoto de Cogumelos com Ervas Finas',           category: 'Vegetariano',kcal: '350 kcal', protein: '12g', tag: 'Novo' },
  { name: 'Macarrão de Abobrinha com Molho de Tomate',     category: 'Vegetariano',kcal: '280 kcal', protein: '10g', tag: null },
  { name: 'Frango Desfiado com Purê de Mandioquinha',      category: 'Infantil',   kcal: '320 kcal', protein: '26g', tag: 'Infantil' },
  { name: 'Carne Moída com Arroz e Cenoura',               category: 'Infantil',   kcal: '360 kcal', protein: '28g', tag: null },
  { name: 'Peito de Peru com Grão-de-bico e Espinafre',    category: 'Proteico',   kcal: '400 kcal', protein: '40g', tag: null },
]

const TAG_COLORS = {
  'Mais vendido': '#f5c200',
  'Premium':      '#aaaaaa',
  'Novo':         '#44bb77',
  'Infantil':     '#5599ff',
}

export default function NossosProdutos() {
  const [activeCategory, setActiveCategory] = useState('Todos')

  const filtered = activeCategory === 'Todos'
    ? PRODUCTS
    : PRODUCTS.filter((p) => p.category === activeCategory)

  return (
    <>
      <Helmet>
        <title>Nossos Produtos – Clean Foods Brasil</title>
        <meta name="description" content="Marmitas congeladas fitness. Sem glúten, sem lactose, sem conservantes. Prontas em 6 minutos, com validade de até 180 dias." />
      </Helmet>

      {/* ===== PAGE HERO ===== */}
      <div style={{ paddingTop: 72 }}>
        <section className="page-hero">
          <Container>
            <Row>
              <Col lg={8}>
                <p className="text-cf-yellow fw-bold text-uppercase small mb-2" style={{ letterSpacing: 2 }}>
                  Clean Foods Brasil
                </p>
                <h1 className="section-title mb-0">
                  Nossos <span className="highlight">Produtos</span>
                </h1>
                <hr className="section-divider" />
                <p style={{ maxWidth: 560, lineHeight: 1.8 }}>
                  Refeições desenvolvidas com curadoria técnica, sem glúten, sem lactose e sem conservantes.
                  Prontas em 6 minutos, com validade de até 180 dias congelados.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </div>

      {/* ===== DESTAQUES ===== */}
      <section className="feature-strip">
        <Container>
          <Row className="gy-3 justify-content-center">
            {[
              { Icon: FaLeaf,      label: 'Sem conservantes & óleos' },
              { Icon: FaClock,     label: 'Pronto em 6 minutos' },
              { Icon: FaSnowflake, label: 'Validade 180 dias' },
              { Icon: FaFireAlt,   label: 'Calorias controladas' },
            ].map(({ Icon, label }) => (
              <Col key={label} xs={6} md={3}>
                <div className="feature-item justify-content-center">
                  <div className="feature-icon"><Icon /></div>
                  <span className="feature-text-title">{label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ===== FILTROS + GRID ===== */}
      <section className="section-padding bg-cf-black">
        <Container>
          {/* Category filter */}
          <div className="d-flex flex-wrap gap-2 mb-5">
            {CATEGORIES.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={activeCategory === cat ? 'btn btn-cf-yellow' : 'btn btn-cf-outline'}
                style={{ fontSize: '0.85rem' }}
              >
                {cat}
              </button>
            ))}
          </div>

          <Row className="gy-4">
            {filtered.map((product, i) => (
              <Col key={i} sm={6} lg={4}>
                <div className="product-card h-100">
                  <ImagePlaceholder height="210px" label={`Foto: ${product.name}`} />
                  <div className="product-card-body">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      {product.tag ? (
                        <span
                          className="product-badge"
                          style={{ background: TAG_COLORS[product.tag] || 'var(--cf-yellow)' }}
                        >
                          {product.tag}
                        </span>
                      ) : (
                        <span className="product-badge" style={{ background: 'var(--cf-gray)', color: 'var(--cf-muted)' }}>
                          {product.category}
                        </span>
                      )}
                    </div>
                    <h5 className="product-card-title mb-3" style={{ fontSize: '0.97rem', lineHeight: 1.4 }}>
                      {product.name}
                    </h5>
                    <div className="d-flex gap-3 mt-auto">
                      <div className="d-flex align-items-center gap-1">
                        <FaFireAlt size={12} className="text-cf-yellow" />
                        <span style={{ fontSize: '0.82rem' }}>{product.kcal}</span>
                      </div>
                      <div className="d-flex align-items-center gap-1">
                        <FaLeaf size={12} className="text-cf-yellow" />
                        <span style={{ fontSize: '0.82rem' }}>Proteína {product.protein}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ===== COMO FUNCIONA ===== */}
      <section className="section-padding bg-cf-dark">
        <Container>
          <div className="text-center mb-5">
            <p className="text-cf-yellow fw-bold text-uppercase small mb-2" style={{ letterSpacing: 2 }}>
              Simples assim
            </p>
            <h2 className="section-title">
              Como <span className="highlight">funciona</span>
            </h2>
            <hr className="section-divider centered mx-auto" />
          </div>
          <Row className="gy-4 text-center">
            {[
              { step: '01', title: 'Escolha seu produto', text: 'Selecione entre as diversas opções de marmitas da linha Clean Foods, todas sem glúten e sem lactose.' },
              { step: '02', title: 'Mantenha congelado',  text: 'Armazene no freezer por até 180 dias sem perder nenhuma propriedade nutricional.' },
              { step: '03', title: 'Aqueça em 6 minutos', text: 'Retire do congelador, leve ao micro-ondas ou banho-maria por 6 minutos e sirva.' },
            ].map(({ step, title, text }) => (
              <Col key={step} md={4}>
                <div className="cf-card p-4 h-100">
                  <div
                    className="mb-3 mx-auto d-flex align-items-center justify-content-center fw-black"
                    style={{
                      width: 64, height: 64, borderRadius: '50%',
                      background: 'var(--cf-yellow)', color: 'var(--cf-black)',
                      fontSize: '1.4rem', fontWeight: 900,
                    }}
                  >
                    {step}
                  </div>
                  <h5 className="fw-bold mb-2">{title}</h5>
                  <p className="mb-0" style={{ fontSize: '0.9rem', lineHeight: 1.7 }}>{text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ===== GARANTIAS ===== */}
      <section
        className="py-5"
        style={{ background: 'var(--cf-yellow)' }}
      >
        <Container>
          <Row className="align-items-center gy-3 text-center text-md-start">
            <Col md={8}>
              <h3 className="fw-black text-uppercase mb-1" style={{ color: 'var(--cf-black)' }}>
                Quer encontrar os produtos perto de você?
              </h3>
              <p className="mb-0 fw-semibold" style={{ color: 'rgba(0,0,0,0.65)' }}>
                Consulte nossos pontos de venda autorizados.
              </p>
            </Col>
            <Col md={4} className="text-md-end">
              <a
                href="/pontos-de-venda"
                className="btn btn-lg fw-bold text-uppercase px-5"
                style={{ background: 'var(--cf-black)', color: 'var(--cf-yellow)', borderRadius: 4 }}
              >
                Ver Pontos de Venda
              </a>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}
